import { Markup } from '@/components/Markup';
import { TiktokTheme } from '@/components/Tiktok/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Tiktok = GenericSlot({ as: Markup, theme: TiktokTheme });
